import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    LANDING_BLOG_NAV_ITEM,
    LANDING_SECTION_NAV_ITEMS,
    scrollToLandingSection,
} from '../lib/landingNav';

const LandingDesktopNav: React.FC = () => {
    const { t } = useTranslation();

    return (
        <nav
            className="hidden lg:flex flex-1 items-center justify-center gap-1 min-w-0 px-2"
            aria-label={t('navigation.menu')}
        >
            {LANDING_SECTION_NAV_ITEMS.map((item) => (
                <button
                    key={item.key}
                    type="button"
                    onClick={() => item.sectionId && scrollToLandingSection(item.sectionId)}
                    className="shrink-0 rounded-lg px-2.5 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent/50 hover:text-foreground"
                >
                    {t(item.labelKey)}
                </button>
            ))}
            <a
                href={LANDING_BLOG_NAV_ITEM.href}
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0 rounded-lg px-2.5 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent/50 hover:text-foreground"
            >
                {t(LANDING_BLOG_NAV_ITEM.labelKey)}
            </a>
        </nav>
    );
};

export default LandingDesktopNav;
